import type { UserDataLoginRecord } from '@navio/nsdk';
import { useAuthContext } from 'noddi-web';

/**
 * Refresh the session copy of the signed-in user after they changed their own
 * details.
 *
 * The session copy is what greets them by name, and nothing else repairs it: a
 * query invalidation refreshes `getAccount` but leaves `useAuthContext().userData`
 * on the old values until a reload. Every endpoint in this flow that returns the
 * updated user goes through here, so a contact save that is never followed by a
 * final confirm still updates the name on screen.
 *
 * `userGroups` is kept from the local copy so the selected profile survives.
 */
export const useUpdateSessionUser = () => {
  const { userData, updateUserData } = useAuthContext();

  return (user: UserDataLoginRecord) => {
    if (!userData) {
      return;
    }
    updateUserData({
      token: userData.token,
      user: { ...user, userGroups: userData.user.userGroups }
    });
  };
};
